import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import * as api from '@/api/adminUsers';

export const ADMIN_USERS_KEY = ['admin-users'] as const;

export function useAdminUsers() {
  return useQuery({ queryKey: ADMIN_USERS_KEY, queryFn: api.listAdminUsers });
}

export function useAddAdminUser() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.addAdminUser,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ADMIN_USERS_KEY });
      qc.invalidateQueries({ queryKey: ['users-stats'] });
    },
  });
}

export function useRemoveAdminUser() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.removeAdminUser,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ADMIN_USERS_KEY });
      qc.invalidateQueries({ queryKey: ['users-stats'] });
    },
  });
}
